<template>
  <section
    id="contact-options"
    class="bg-gradient-to-t from-white to-primary/10 py-10"
    role="region"
    aria-labelledby="contact-heading">
    <div class="mx-auto max-w-4xl px-4 sm:px-6 md:px-8">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 justify-items-center">
        <ContactOption
          icon="📧"
          :title="$t('contact.options.ticket.title')"
          :description="$t('contact.options.ticket.description')"
          :active="mode === 'ticket'"
          @select="mode = 'ticket'" />

        <ContactOption
          icon="📅"
          :title="$t('contact.options.consult.title')"
          :description="$t('contact.options.consult.description')"
          :active="mode === 'consult'"
          @select="mode = 'consult'" />
      </div>
      <div v-if="mode" class="mt-8">
        <component :is="currentComponent" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useContactOptions } from "@/composables/useContactOptions";

import ContactOption from "@/components/ContactOption.vue";
const { mode, isChatLive, currentComponent } = useContactOptions();
</script>
